import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import globals from '../../globals';
import animations from './animations';
import Heading from "../../elements/Heading";
import Button from "../../elements/Button";

class HeroHome extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        animations.initiate(this.refTitle, this.refFormBtn, this.refLeadCopy);
    }

    componentDidUpdate() {
        animations.play();
    }

    render() {
        let paragraphs = [];
        this.props.leadCopy.map((paragraph, key) => {
            paragraphs.push(
                <p key={key}>{paragraph}</p>
            );
        });

        return (
            <section className="hero">
                <div className="hero-bg"/>
                <div className="row">
                    <div className="col-md-5 col-md-offset-2 col-sm-12 text-sm-center text-xs-center">
                        <Heading title={this.props.title} ref={el => this.refTitle = el} />
                        <div className="hero-copy row">
                            <div className="col-xs-12" ref={el => this.refLeadCopy = el}>
                                {paragraphs}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-md-offset-1 col-sm-12 text-sm-center text-xs-center">
						<div ref={el => this.refFormBtn = el}>
							<Button
								newClass="hero-cta"
								image="/images/btn-email-us.svg"
								alt="Email Us"
								action={event => {
									globals.pushEvent('contactFormOpenHomepageButton');
									window.slideFormContainer ? window.slideFormContainer.animateIn(event) : null;
								}}
								dontWobble={true}
							/>
							<Button
								image="/images/btn-price-checker.svg"
								alt="Price Checker"
								action={event => {
									globals.pushEvent('businessFibreGlobalHomepageButton');
									this.props.history.push('/internet');
								}}
								dontWobble={true}
							/>
						</div>
                        <span className="banner-trigger"/>
                    </div>
                </div>
            </section>
        );
    }

}

export default withRouter(HeroHome);


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/HeroHome/HeroHome.js